module.exports = __webpack_public_path__ + "static/media/icon-nf.03e0c1dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-nf.svg
// module id = 3243
// module chunks = 0